export const selectFilter = (state) => state.filterValue.filter;
